import { FORM } from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';

export default function formGroupAttributAdd(){

    var obj = {
        titleForm: "Ajouter un groupe d'attributs",
        subTitleForm: "Veuillez compléter les champs ci-dessous pour créer votre groupe d'attributs",
        langSelect: true,
        drawerType: 'swipeable',
        noForm: true,
        component: Button,
        formConfig: {
            type: FORM,
            children: [
                {
                    optionsInputs: [
                        {
                            type: 'text',
                            label: 'Libellé',
                            helper: {
                                text: 'Libellé du groupe d\'attribut',
                                link: false,
                            },
                            required: false,
                            stateName: 'groupName',
                            translated: true
                        },
                        {
                            type: 'text',
                            label: 'Identifiant',
                            helper: {
                                text: 'Identifiant du groupe d\'attribut',
                                link: false,
                            },
                            required: true,
                            stateName: 'groupIdentifier',
                            translated: false
                        },
                    ]
                },
            ]
        }
    }
    return obj;
}